/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { OrderStatusResponse } from '../models/order-status-response';
import { OrderResponse } from '../models/order-response';
import { OrderRequestDto } from '../models/order-request-dto';
@Injectable({
  providedIn: 'root',
})
class ExternalOrderService extends __BaseService {
  static readonly getExternalOrderStatusPath = '/ExternalOrder/Status';
  static readonly postExternalOrderOrderPath = '/ExternalOrder/Order';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param trnId undefined
   * @return Success
   */
  getExternalOrderStatusResponse(trnId?: string): __Observable<__StrictHttpResponse<OrderStatusResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (trnId != null) __params = __params.set('trnId', trnId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ExternalOrder/Status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OrderStatusResponse>;
      })
    );
  }
  /**
   * @param trnId undefined
   * @return Success
   */
  getExternalOrderStatus(trnId?: string): __Observable<OrderStatusResponse> {
    return this.getExternalOrderStatusResponse(trnId).pipe(
      __map(_r => _r.body as OrderStatusResponse)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  postExternalOrderOrderResponse(body?: OrderRequestDto): __Observable<__StrictHttpResponse<OrderResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ExternalOrder/Order`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OrderResponse>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postExternalOrderOrder(body?: OrderRequestDto): __Observable<OrderResponse> {
    return this.postExternalOrderOrderResponse(body).pipe(
      __map(_r => _r.body as OrderResponse)
    );
  }
}

module ExternalOrderService {
}

export { ExternalOrderService }
